import React, { useEffect } from 'react';
import { Facebook, Google } from "@mui/icons-material";
import { Link, useLocation, useHistory } from "react-router-dom";
import Style from "./register.module.scss"
import Language from "../../../i18n/english.json";
import { AuthContext } from '../../../context/auth/ApiContext';
import { CircularProgress } from '@mui/material';
import axios from "axios";
import { errorMessage } from '../../../utils/notification';
import { toast } from 'react-toastify';
import { settingContext } from '../../../context/Setting/Setting';
import { Company, Footer, MenuBar } from '../../../layout/welcome';
import { TextInput } from "../../../components";
import PhoneInput from 'react-phone-input-2'

const Register = () => {
  const [isLoading, setLoading] = React.useState(false);
  const [input, setInput] = React.useState({});
  const { page, loading } = React.useContext(settingContext);
  const { user, dispatch, isFetching, changeToken, changeAuthUser } =
    React.useContext(AuthContext);
  const router = useHistory();

  useEffect(() => {
    setLoading(false);
    // if (user) {
    //   let url = "/student/home";
    //   router.push(url);
    // }
  }, [user]);

  const handleInputs = (label, e) => {
    var val = e.target.value;
    setInput({ ...input, [label]: val });
  };

  const handlePhoneInput = (label, e) => {
    var val = e;
    setInput({ ...input, [label]: val });
  }

  const registerFunction = async (e) => {
    e.preventDefault();
    setLoading(true);
    input["device_name"] = navigator.userAgent;
    const res = await axios
      .post(process.env.REACT_APP_API_URL + "/auth/register", input, {
        "Content-type": "application/json",
      })
      .then((resp) => {
        const { data } = resp;
        setLoading(false);
        if (data?.message === 'success') {
          router.push("/auth/login?type=success");
        }
      })
      .catch((error) => {
        const err = error?.response?.data;
        errorMessage(toast, err.message);
        setLoading(false)
      });
  };

  const isNumberKey = (evt) => {
    var charCode = (evt.which) ? evt.which : evt.keyCode
    if (charCode > 31 && (charCode < 48 || charCode > 57))
      return false;
    return true;
  }

  return (
    <div id="page-top" class="home">
      <div id="page-wrap">
        <MenuBar menuIndex="auth" setting={page?.setting} loader={loading} />
        <section id="login-content" className="login-content" >
          <div className="awe-parallax bg-login-content" style={{ backgroundImage: 'url(../img/bg.jpg)' }}></div>
          <div className="awe-overlay" />
          <div className="container">
            <div className="">
              {/* FORM */}
              <div className="md:float-right">
                <div className="form-login">
                  <form>
                    <h2 className="text-uppercase">Register</h2>
                    <div className="form-email">
                      <input
                        type="text"
                        onChange={(e) => handleInputs("username", e)}
                        className="l_r_b"
                        placeholder="Username"
                      />
                    </div>
                    <div className="form-email">
                      <input
                        id='form-email'
                        type="text"
                        onChange={(e) => handleInputs("email", e)}
                        className="l_r_b"
                        placeholder="Email"
                      />
                    </div>
                    <div className="form-email">
                      <PhoneInput
                        country={'ng'}
                        value={input['phone']}
                        onChange={phone => handlePhoneInput("phone", phone)}
                      />
                      {/* <input
                        id='form-phone'
                        type="tel"
                        onkeypress={(event) => isNumberKey(event)}
                        onChange={(e) => handleInputs("phone", e)}
                        className="l_r_b"
                        placeholder="Mobile Number"
                      /> */}
                    </div>
                    <div className="form-password">
                      <input
                        id='form-password'
                        onChange={(e) => handleInputs("password", e)}
                        type="password"
                        placeholder="Password" />
                    </div>
                    <div className="form-submit-1">
                      <button
                        disabled={isLoading}
                        onClick={registerFunction}
                        type="submit"
                        defaultValue="Sign In"
                        className="mc-btn btn-style-1" >
                        {!isLoading && `Submit`}
                        {isLoading && (
                          <div className="d-flex flex-row align-center">
                            <CircularProgress
                              size={15}
                              sx={{ color: "white", marginRight: 2 }}
                            />
                            <p>Connecting</p>
                          </div>
                        )}
                      </button>
                    </div>
                    <div className="link">
                      <Link to={"/auth/login"}>
                        <i className="icon fa-solid fa-circle-arrow-right" /> Already have an account yet? Sign In
                      </Link>
                    </div>
                  </form>
                </div>
              </div>
              {/* END / FORM */}
              <div className="image auth-image">
                <img src={process.env.REACT_APP_LOCAL_FILE_PATH + "page/large/" + page?.page_slide?.image} alt="" />
              </div>
            </div>
          </div>
        </section>
        <Footer setting={page?.setting} />
      </div>
    </div>
  );
};

export default Register;